import type { RefObject } from "react";
import type { GPEventResponse } from "../../../types";
import { _any } from "i18n";
import "./eventList.css";
import "./EventInVideo.css";
import { calculateEventTime, handlePlayEvent } from "../../../functions";
import type { MediaPlayerInstance } from "@vidstack/react";
import { useTimeStore } from "../../../time-store";

interface EventInVideoProps {
	events: GPEventResponse[];
	playerRef: RefObject<MediaPlayerInstance> | null;
	fullscreenSidebar?: boolean;
	isClip?: boolean;
}

export function EventInVideo({ fullscreenSidebar, events, isClip, playerRef }: EventInVideoProps) {
	const { currentTime } = useTimeStore();

	if (events.length === 0) {
		return null;
	}

	if (isClip) {
		events = events.map(
			(e) =>
				({
					...e,
					videoTime: e.clipTime,
				}) as GPEventResponse,
		);
	}

	const nearestEvent: GPEventResponse | undefined = events.findLast((e) => e.videoTime <= currentTime) ?? events[0];

	const isHighlight = nearestEvent?.type === "highlight";
	const nextEvent = events.find((e) => e.videoTime >= currentTime && (!nearestEvent || nearestEvent.id !== e.id));
	const previousEvent = events.findLast((e) => e.videoTime <= currentTime && (!nearestEvent || nearestEvent.id !== e.id));

	const handleOnNavigate = (event: GPEventResponse | undefined) => {
		if (event) {
			handlePlayEvent(playerRef, event.videoTime);
		}
	};

	if (!nearestEvent) {
		return null;
	}

	return (
		<div className="gameVideo-event" style={fullscreenSidebar ? { left: "calc(50% - 210px)" } : {}}>
			<div className={`gameVideo-event__previous ${previousEvent ? "" : "is-disabled"}`} onClick={() => handleOnNavigate(previousEvent)} />
			<div className="gameVideo-event__content">
				<div className="gameVideo-event__subject">{`${calculateEventTime(nearestEvent)} ${_any(`event.v3.type.${nearestEvent.type}`)}`}</div>
				{isHighlight ? (
					<div className="gameVideo-event__tags">
						<span className="gameVideo-event__tag">{nearestEvent.details?.title}</span>
					</div>
				) : (
					<div className="gameVideo-event__tags">
						{!!nearestEvent.backNumber && <span className="gameVideo-event__tag">#{nearestEvent.backNumber}</span>}
						<span className="gameVideo-event__tag">{nearestEvent.playerName}</span>
					</div>
				)}
			</div>
			<div className={`gameVideo-event__next ${nextEvent ? "" : "is-disabled"}`} onClick={() => handleOnNavigate(nextEvent)} />
		</div>
	);
}
